import { render } from "./ProductsReportTableLoading.vue?vue&type=template&id=aa094b12"
import script from "./ProductsReportTableLoading.vue?vue&type=script&lang=js"
export * from "./ProductsReportTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__